import Image1 from "../../assets/Image1.png";
import Image2 from "../../assets/Image2.png";
import Image3 from "../../assets/imageloop.png";
import Image4 from "../../assets/Image4.png";
import Image5 from "../../assets/Image5.png";
import Image6 from "../../assets/Image6.png";
import Image7 from "../../assets/movienative.png";
import Image8 from "../../assets/nativequiz.png";
import Image9 from "../../assets/gymfit.png";
import Image10 from "../../assets/nativemovie.png";
import Image11 from "../../assets/events.png";
import Image0 from "../../assets/image1_1.png"
import Image00 from "../../assets/imageai.png"
import Image001 from "../../assets/image1_2.png"
import Image002 from "../../assets/fistula.png"
// import Image8 from '../../assets/Image8.png'

const data = [
  {
    id: 0,
    category: "fullstack",
    image: Image00,
    title: "Ai Resume Analyzer",
    desc: "React Tailwindcss Puter.js",
    demo: "https://ai-resume-analyzer-psi-sepia.vercel.app/",
    github: "https://github.com/bashytech007/ai-resume-analyzer",
  },
  {
    id: 1,
    category: "fullstack",
    image: Image0,
    title: "(FullStack)Ecommerce Fragnances",
    desc: "React Tailwindcss React-Query",
    demo: "https://mhkasa-front.vercel.app/",
    github: "https://github.com/bashytech007/mhkasa-front",
  },
   {
    id: 3,
    category: "frontend",
    image: Image002,
    title: "An Ngo Site For VVF Cases built with  typescript and React",
    desc: "A volunteer site about VVF CASES in Nigeria i built almost all the pages here(collaboration)",
    demo: "https://fistulacareinitiative.org/",
    github: "https://github.com/Olatade/fistulacareinitiative.org",
  },
  {
    id: 6,
    category: "frontend",
    image: Image3,
    title: "Loop Studios",
    desc: "A VR gaming Platform",
  demo: "https://loopstudios-pied.vercel.app/",        // ✅ Fixed
  github: "https://github.com/bashytech007/loopstudios", // ✅ Fixed
  },
  {
    id: 2,
    category: "frontend",
    image: Image001,
    title: "Landing Page Built With React",
    desc: "A landing page for a legal company coped during an hackhathon",
    demo: "https://toyin.vercel.app/",
    github: "https://github.com/bashytech007/Toyin",
  },
 
  {
    id: 4,
    category: "fullstack",
    image: Image1,
    title: "(FullStack)Ecommerce Boutique",
    desc: "An ecommerce site that sells wears sneakers etc",
    demo: "https://bash-clothing-j7kl1zsx3-bashytech007.vercel.app/",
    github: "https://github.com/bashytech007/bash-clothing",
  },
  
  {
    id: 5,
    category: "frontend",
    image: Image2,
    title: "ManageLandingPage(Frontend)",
    desc: "Manage landing page from frontendmentor.io/",
    demo: "https://jade-halva-da043a.netlify.app/",
    github: "https://github.com/bashytech007/manageLandingPage",
  },
  
  {
    id: 7,
    category: "frontend",
    image: Image4,
    title: "omniFood(Frontend)",
    desc: "A fictional ai food company",
    demo: "https://omnifood-bash.netlify.app",
    github: "https://github.com/bashytech007/omnifood",
  },

  {
    id: 8,
    category: "frontend",
    image: Image6,
    title: "Bashsocials",
    desc: "A fictional social media  i made that has a look of facebook and twitter",
    demo: "https://socials-bash.vercel.app//",
    github: "https://github.com/bashytech007/Socials",
  },

  {
    id: 9,
    category: "mobile/native",
    image: Image7,
    title: "MovieFlix",
    desc: "A Movie Site that shows ratings ,trailers from TMDB api using Expo",
    demo: "https://bashy007-movieapp--60fhh26q70.expo.app/",
    github: "https://github.com/bashytech007/TMDBMovieapp-RN",
  },
  {
    id: 12,
    category: "mobile/native",
    image: Image8,
    title: "Premier Trivia",
    desc: "A Premeier League Quiz App built with Expo",
    demo: "https://bashy007-quiz--kje3jhv3g4.expo.app/",
    github: "https://bashy007-quiz--kje3jhv3g4.expo.app/",
  },
  {
    id: 13,
    category: "mobile/native",
    image: Image9,
    title: "GYM FIT",
    desc: "A Gym App that tracks workout sessions",
    demo: "https://bash-gymapp--i30jd2je7g.expo.app/",
    github: "https://github.com/bashytech007/Expo-54-with-nativewind",
  },
    {
    id: 11,
    category: "mobile/native",
    image: Image10,
    title: "MovieFlix",
    desc: "A Movie App built with React Native CLi on Android Studio",
    demo: "https://youtube.com/shorts/vLRj3JNOb-s",
    github: "https://github.com/bashytech007/movieproject",
  },
  {
    id: 10,
    category: "mobile/native",
    image: Image11,
    title: "PhotoSharing App",
    desc: "A Photo Sharing App where you can share events with friends built with Supabase and Expo",
    demo: "https://photosharing--mxosbff896.expo.app/",
    github: "https://github.com/bashytech007/Photosharing",
  },

  // {
  //   id: 11,
  //   category: "backend",
  //   image: Image7,
  //   title: "BATFARM(FRONTEND)",
  //   desc: "A fictional batfarm site that shows diffrenet crops grown in nigeria and details about them",
  //   demo: "https://thebatfarm.onrender.com/",
  //   github: "https://github.com/bashytech007/Expo-54-with-nativewind",
  // },
  //   {
  //     id: 12,
  //     category: "backend",
  //     // image: Image8,
  //     title: "FriendsApp(Backend)",
  //     desc: "An api that can be used for friends",
  //     demo: "image8",
  //     github: "https://github.com/bashytech007/backendclass",
  //   },
];

export default data;
